import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

export default function SimpleLanguageSwitcher({ variant = 'default' }) {
  const { changeLanguage, currentLanguage } = useTranslation();

  const languages = [
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' }
  ];

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
  };

  // Стили для разных вариантов
  const getStyles = () => {
    if (variant === 'mobile') {
      return {
        icon: 'h-4 w-4 text-gray-600',
        button: (isActive) => `text-base font-medium transition-colors px-3 py-2 rounded ${
          isActive 
            ? 'text-rose-600 bg-rose-50 border border-rose-200' 
            : 'text-gray-600 hover:text-rose-600 hover:bg-gray-50'
        }`
      };
    }
    
    // Дефолтные стили для header
    return {
      icon: 'h-5 w-5 text-white',
      button: (isActive) => `text-lg font-medium transition-colors px-2 py-1 rounded hover:bg-white/10 ${
        isActive 
          ? 'text-rose-400 bg-white/20' 
          : 'text-white hover:text-rose-400'
      }`
    };
  };

  const styles = getStyles();

  return (
    <div className="relative">
      <div className="flex items-center gap-3">
        <Globe className={styles.icon} />
        {languages.map((language) => (
          <button
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            className={styles.button(currentLanguage === language.code)}
          >
            {language.flag}
          </button>
        ))}
      </div>
    </div>
  );
}
